import { render, staticRenderFns } from "./ShopTimes.vue?vue&type=template&id=3b332e29"
import script from "./ShopTimes.vue?vue&type=script&lang=js"
export * from "./ShopTimes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports